"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var AppMarket = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M5.37,5 L19.679,5 C19.926,5 20.136,5.18 20.173,5.424 L21,10 C21.022,11.197 20.176,12.234 19,12.453 L19,18 C19,19.104 18.104,20 17,20 L8,20 C6.896,20 6,19.104 6,18 L6,12.45 C4.834,12.216 3.995,11.189 4,10 C4,9.953 4.888,5.367 4.888,5.367 C4.948,5.15 5.145,5 5.37,5 Z M5.385,11.115 C5.64,11.369 5.984,11.51 6.339,11.51 C6.392,11.51 6.446,11.506 6.5,11.5 C7.588,11.5 8.5,10 8.5,10 C8.749,10.893 9.566,11.509 10.494,11.5 C11.423,11.504 12.241,10.892 12.5,10 C12.84,10.829 13.609,11.406 14.5,11.5 C15.392,11.406 16.159,10.829 16.5,10 C16.5,10 17.5,11.5 18.5,11.5 C18.906,11.531 19.306,11.382 19.594,11.094 C19.882,10.806 20.03,10.406 20,10 L19.25,6 L5.75,6 L5,10 C4.95,10.411 5.092,10.822 5.385,11.115 Z M16,17 L9,17 L9,12.059 C8.81,11.895 8.641,11.708 8.5,11.5 C8.131,11.987 7.598,12.324 7,12.449 L7,18 C7,18.552 7.447,19 8,19 L17,19 C17.553,19 18,18.552 18,18 L18,12.442 C17.406,12.311 16.877,11.978 16.5,11.5 C16.361,11.711 16.193,11.9 16,12.063 L16,17 Z M12.5,11.5 C12.06,12.125 11.349,12.482 10.609,12.482 C10.407,12.482 10.202,12.455 10,12.4 L10,16 L15,16 L15,12.4 C14.06,12.658 13.06,12.298 12.5,11.5 Z" })));
};
AppMarket.displayName = 'AppMarket';
exports.default = AppMarket;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=AppMarket.js.map